import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';

/**
 * The `root` variable represents the root DOM node where the React application
 * will be rendered. It is created using `ReactDOM.createRoot`, which initializes
 * the rendering process for the React application in a specific container element.
 *
 * In this case, the container is a DOM element with the ID 'root'.
 *
 * `ReactDOM.createRoot` enables the use of the React 18 concurrent features.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);